module.exports = __webpack_public_path__ + "static/media/card-unimed.949893f4.png";